import { Injectable } from '@angular/core';

// numeric severity values allow for mathematical threshold implementation for
// handlers; ts enums also provide reverse mapping so Severity[10] == "DEBUG"
// https://www.typescriptlang.org/docs/handbook/enums.html#reverse-mappings
export enum Severity {
    DEBUG = 10,
    INFO = 20,
    WARNING = 30,
    ERROR = 40,
}

export abstract class BaseLogHandler {
  // msg may be arbitrary object with unknown members; allow any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public abstract log(datestr: string, severity: Severity, msg: any): Promise<void>;
}

export class ConsoleLogHandler extends BaseLogHandler {
  // msg may be arbitrary object with unknown members; allow any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async log(datestr: string, severity: Severity, msg: any): Promise<void> {
    // reverse-map Severity value back to human-readable name
    console.log(datestr, Severity[severity], msg);
  }
}

export class AppInsightsLogHandler extends BaseLogHandler {
  // TODO: remove eslint-disable no-unused-vars lines when implemented
  /* eslint-disable @typescript-eslint/no-unused-vars */

  // msg may be arbitrary object with unknown members; allow any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async log(datestr: string, severity: Severity, msg: any): Promise<void> {
    // TODO: AppInsightsLogService.log(datestr, Severity[severity], msg);
  }

  /* eslint-enable @typescript-eslint/no-unused-vars */
}

@Injectable({
  providedIn: 'root'
})
export class LogService {
  handlers: BaseLogHandler[] = [];

  constructor() {
    this.handlers.push(new ConsoleLogHandler());
  }

  addHandler(logHandler: BaseLogHandler) {
    this.handlers.push(logHandler);
  }

  now() {
    return new Date().toISOString();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async log(severity: Severity, msg: any) {
    // datestr should be exactly the same for all handlers
    const datestr: string = this.now();

    for (let i = 0; i < this.handlers.length; i++) {
      const handler: BaseLogHandler = this.handlers[i];
      handler.log(datestr, severity, msg);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async error(msg: any) { this.log(Severity.ERROR, msg); }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async warning(msg: any) { this.log(Severity.WARNING, msg); }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async info(msg: any) { this.log(Severity.INFO, msg); }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async debug(msg: any) { this.log(Severity.DEBUG, msg); }
}
